import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import { fragmentsPermissions } from '@app/modules/fragments/fragments-permissions';
import { publishMessages } from '@app/modules/social-export/publish';
import { QueryView } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useComposition } from '../../hooks/useComposition';
import { ComposeSocialExportPanorama } from './ComposeSocialExportPanorama';
import { ComposeSocialExportPublishDropdown } from './ComposeSocialExportPublishDropdown';
import { useCompositionSocialUploadsQuery } from './useCompositionSocialUploadsQuery';

/**
 * Composition social export block: platform bar first, then uploads list.
 */
export function ComposeSocialPublishView() {
  const { composition } = useComposition();
  const uploadsQuery = useCompositionSocialUploadsQuery(composition.id);

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <QueryView query={uploadsQuery} inline>
        {() => {
          const publicationsCount = Array.from(uploadsQuery.data?.values() ?? []).flat().length;

          return (
            <Box>
              <ContentCluster message={publishMessages.publishToSectionTitle} divider={false}>
                <ComposeSocialExportPublishDropdown />
              </ContentCluster>
              <ContentCluster
                message={publishMessages.publicationsSectionTitle}
                values={{ count: publicationsCount }}
              >
                <ComposeSocialExportPanorama uploadsByPlatform={uploadsQuery.data} />
              </ContentCluster>
            </Box>
          );
        }}
      </QueryView>
    </IfPermission>
  );
}
